import { DialogService } from 'aurelia-dialog';
import { inject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import FsUtility from '../../../../Lib/Fs.SmartClient.Client/FsUtility';
import { useView, autoinject, Container } from 'aurelia-framework'
import { EventAggregator } from 'aurelia-event-aggregator';
import { PLATFORM } from 'aurelia-pal';
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import { fromLonLat, transformExtent } from 'ol/proj';
import { OSM, XYZ, TileJSON, Vector as VectorSource } from 'ol/source';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import Point from 'ol/geom/Point';
import { Overlay } from 'ol';
import TabViewModel from '../../../../Lib/Fs.SmartClient.Client/TabViewModel';
import GeoJSON from 'ol/format/GeoJSON';
import PublicAirQualityMapAppService from '../../Scripts/AppServiceContract/PublicAirQualityMapAppService';
import { Fill, Icon, Style, Text, Stroke, Circle } from 'ol/style';
import { toContext } from 'ol/render';
import { fs } from '../../../../Config/FsConfig';
import AirQualityCalculateItemData from '../../Scripts/AppServiceContract/AirQualityCalculateItemData';
import StationAirQualityData from '../../Scripts/AppServiceContract/StationAirQualityData';
import PublicAppService from '../../Scripts/AppServiceContract/PublicAppService';
import DashboardAppService from '../../Scripts/AppServiceContract/DashboardAppService';
import StationParameter from '../../Scripts/AppServiceContract/StationParameter';
import DistrictAppService from '../../Scripts/AppServiceContract/DistrictAppService';
import DistrictData from '../../Scripts/AppServiceContract/DistrictData';
import DistrictParameter from '../../Scripts/AppServiceContract/DistrictParameter';
import Popover from 'bootstrap/js/dist/popover';
declare var Windy: any;

@autoinject()
@useView(PLATFORM.moduleName("./MapMonitoringSearchView.html"))
export default class MapMonitoringSearchVM extends TabViewModel {
  public dialogService: DialogService;
  public i18n: I18N;
  public eventAggregator: EventAggregator;
  public currentLocale: string;
  public AirQualityIndexItemList: any;
  public thisAqsIndexpm25: any;
  public changeLocaleSubscribe: any;
  public ListDistrict: any;
  public ListDistrictFilter: any;
  public ListDistrictGroup: any;
  public Today: string;
  public AirQualityIndexList: any;
  public valueAirQualityIndexHealthRecommend: number = 0;
  public ShowStationPic: boolean = false;
  public Placeholder: string;

  /*Maps*/
  map: any;
  view = new View({
    center: fromLonLat([100.50231745637795, 13.75512316215497]),
    zoom: 10
  });
  public ColorMaps: any;
  chart: any;
  vectorLayer: any;
  LineAreaLayer: any;
  vectorSource: any;

  ShowPopup: boolean;
  DataStation: any;
  AQIData: any;
  StationTime: string;
  AirQualityMax: number;
  AirQualityList: any;
  AirQualityCalculateData: any;
  StationData: any;

  public districtGroupId: string;
  airQualityArea: any;
  AttachmentBaseUrl: string;
  get DistrictGroupId(): string {
    return this.districtGroupId
  }
  set DistrictGroupId(data: string) {
    var self = this
    self.districtGroupId = data;

    if (data != null && data != "") {
      self.ListDistrictFilter = self.ListDistrict.filter(t => t.DistrictGroupId == data);
      this.LoadMapLayer(self.AirQualityAreaDatas);
    } else {
      self.ListDistrictFilter = self.ListDistrict;
      this.LoadMapLayer(self.AirQualityAreaDatas);
    }
  }

  public districtId: string;
  get DistrictId(): string {
    return this.districtId
  }
  set DistrictId(data: string) {
    var self = this
    self.districtId = data;
    this.LoadMapLayer(self.AirQualityAreaDatas);
  }

  public AirQualityAreaDatas: any;
  attached() {
    this.LoadMap();
    new Popover(document.querySelectorAll('[data-bs-toggle="popover"]')[0]);
  }

  constructor(i18n: I18N, eventAggregator: EventAggregator) {
    super();
    var self = this;
    self.i18n = i18n;
    self.eventAggregator = eventAggregator;
    let dateTime = new Date();
    self.currentLocale = sessionStorage.getItem("CurrentSystemLocale");
    if (this.currentLocale == "th") {
      self.Placeholder = "เลือกสถานี";
    }
    else {
      self.Placeholder = "Select station";
    }
    self.AttachmentBaseUrl = fs.Config.ServiceBaseUrl + "modules/Aqs.AppService/UploadFileAppService/DownloadFile/id=";
    self.PrepareDropdown().then(() => {
      self.SearchArea();
    });
    self.LoadAirQualityIndexList();
    self.LoadAirQualityIndexItemList();

    self.changeLocaleSubscribe = self.eventAggregator.subscribe('ChangeLocale', (response) => {
      var currentLocale = self.i18n.i18next.language == null ? "th-th" : (self.i18n.i18next.language == "th" ? "th-th" : "en-US");

      self.Today = new Intl.DateTimeFormat(currentLocale, { dateStyle: 'full' }).format(dateTime);
      self.PrepareDropdown().then(() => {
        //this.SearchArea();
      });
    });
  }

  SearchArea() {
    var service = this.container.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.Find2()
      .done((result) => {
        this.StationData = result;
        this.FindAirQualityArea();
      }).fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  PrepareDropdown() {
    var defered = $.Deferred();
    var ajax = this.DistrictDropdown();
    var ajax2 = this.DistrictGroupDropdown();
    var ajax3 = this.LoadAirQualityIndexList();

    $.when(ajax, ajax2, ajax3).done(function (r1) {
      defered.resolve(null);
    });

    return defered.promise();
  }

  DistrictDropdown() {
    var self = this;
    var service = Container.instance.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.DistrictDropdown()
      .done((result) => {
        self.ListDistrict = result;
        self.ListDistrictFilter = self.ListDistrict;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  DistrictGroupDropdown() {
    var self = this;
    var service = Container.instance.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.DistrictGroupDropdown()
      .done((result) => {
        self.ListDistrictGroup = result;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }


  async LoadAirQualityIndexList() {
    var self = this;
    var service = Container.instance.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.AirQualityIndexList()
      .done((result) => {
        this.AirQualityIndexList = result;
      })
      .fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  async LoadAirQualityIndexItemList() {
    var self = this;
    var service = Container.instance.get(PublicAppService) as PublicAppService;
    service.AirQualityIndexItemPMforMobile()
      .done((result) => {
        self.AirQualityIndexItemList = result;

      })
      .fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }



  FindAirQualityArea() {
    var self = this;
    var service = self.container.get(PublicAirQualityMapAppService) as PublicAirQualityMapAppService;
    service.FindAirQualityArea()
      .done((result) => {
        self.AirQualityAreaDatas = result;
        this.LoadMapLayer(result);
      }).fail((error) => {
        FsUtility.CommonErrorHandler(error);
      });
  }

  public stationId: string;
  set StationId(data: string) {
    var self = this;
    self.stationId = data;
    var station = self.StationData.find((t) => t.StationId == data);
    self.OpenDailog(station);
    //debugger
  }

  FirstData: any;
  FirstData2: any;
  Test: any;
  Icon: any;
  OpenDailog(stationdata: StationAirQualityData) {
    var self = this;
    var data = [];
    self.ShowPopup = true;
    this.FirstData = stationdata;
    self.FirstData2 = stationdata.AirQualityPM25;

    var AirQualityIndexItem = self.AirQualityIndexItemList?.find((t) => t.Name == "PM2.5"
      && Number(self.FirstData2.AverageAQI) >= t.Min
      && (Number(self.FirstData2.AverageAQI) <= t.Max || t.Max == null));

    var AirQualityIndexpm25 = self.AirQualityIndexList?.find((t) => t.Id == AirQualityIndexItem?.AirQualityIndexId);
    self.thisAqsIndexpm25 = AirQualityIndexpm25;

    this.Icon = "data:image/png;base64, " + this.FirstData2.AqsIcon;
    this.Test = stationdata.AirQualityCalculateItemDatas.filter(t => t.AqsTypeCode != "PM2.5");
    this.SetData(stationdata.AirQualityCalculateItemDatas);
  }

  SetData(AirQualityCalculateData) {
    if (AirQualityCalculateData != null) {
      let dateTime = new Date(AirQualityCalculateData[0].DateTime);
      this.StationTime = new Intl.DateTimeFormat('th-th', { timeStyle: 'short' }).format(dateTime) + " น.";
    }
  }



  LoadMap() {
    var self = this;
    self.map = new Map({
      view: self.view,
      layers: [
        new TileLayer({
          source: new XYZ({
            url: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
          })
        })
      ],
      target: 'map'
    });
  }

  LoadMapLayer(data) {
    var self = this
    self.airQualityArea = data;
    if (data != null) {
      if (self.DistrictId != null && self.DistrictId != "") {
        data = data.filter(t => t.Id == self.DistrictId);
      }

      self.flyTo(fromLonLat([data[0].LongitudeCenter, data[0].LatitudeCenter]), data[0].Zoom);
      self.addLayerPolygon(data[0].PolygonJSON);
    }

    self.LoadStationOnMap();
  }

  LoadStationOnMap() {
    var self = this;

    if (self.vectorLayer != null) {
      self.map.removeLayer(self.vectorLayer);
    }

    if (self.StationData == null) return;
    var data = self.StationData;

    if (self.DistrictId != null && self.DistrictId != "") {
      data = self.StationData.filter(t => t.DistrictId == self.DistrictId);
    }
    else if (self.DistrictGroupId != null && self.DistrictGroupId != "") {
      data = self.StationData.filter(t => t.DistrictGroupId == self.DistrictGroupId);
    }
    var features = new Array(data.length);
    for (let i = 0; i < data.length; ++i) {

      if (data[i].AirQualityPM25 != null) {
        var firstdata = data[i].AirQualityPM25;
        var mainAqi = (firstdata.AverageAQI).toString();
      } else {
        var firstdata = null;
        var mainAqi = null;
      }
      var icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20" width="100" height="100"><style>.s0 { fill:' + firstdata.AirQaulityIndexColorCode + '; stroke: #484848 } .s1 { fill: #ffffff } .t0 {font-size:8px; font-family:Cordia New;font-weight: bold; fill:#000000} </style><path id="Layer" class="s0" d="m6.8 18.9c-1-1.1-2.6-3.1-3.9-5.1-0.6-1.1-1.2-2.1-1.7-3.2-0.4-1-0.7-2-0.7-2.8 0-4.1 3.4-7.3 7.5-7.3 4.1 0 7.5 3.2 7.5 7.3 0 0.8-0.3 1.8-0.7 2.8-0.5 1.1-1.1 2.1-1.7 3.2-1.4 2-2.9 4-3.9 5.1-0.6 0.8-1.8 0.8-2.4 0z" /><path id="Layer" class="s1" d="m8 13c-2.8 0-5-2.2-5-5 0-2.8 2.2-5 5-5 2.8 0 5 2.2 5 5 0 2.8-2.2 5-5 5z" /><text x="50%" y="50%" text-anchor="middle" class="t0">' + $.trim(mainAqi) + '</text></svg>';

      features[i] = new Feature({
        geometry: new Point(fromLonLat([data[i].Longitude, data[i].Latitude])),
        data: data[i],
        Latitude: data[i].Latitude,
        Longitude: data[i].Longitude,
        Value: data[i].Value,
      });

      features[i].setStyle(
        new Style({
          image: new Icon({
            opacity: 1,
            src: 'data:image/svg+xml;utf8,' + escape(icon),
            scale: 0.5
          }),
          //text: new Text({
          //  text: $.trim(mainAqi),
          //  font: 'bold 16px Calibri,sans-serif',
          //  fill: new Fill({
          //    color: 'black',
          //  }),
          //  offsetY: -5,
          //}),
        })
      );

    }

    self.vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: features,
      }),

    });

    self.map.addLayer(self.vectorLayer);

    var container = document.getElementById('popup');
    var content = document.getElementById('popup-content');
    var closer = document.getElementById('popup-closer');

    var overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });
    this.map.addOverlay(overlay);

    closer.onclick = function () {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    var self = this;

    this.map.on('singleclick', function (event) {
      if (self.map.hasFeatureAtPixel(event.pixel) === true) {
        var coordinate = event.coordinate;
        var features = self.map.getFeaturesAtPixel(event.pixel);
        content.innerHTML = features[0].getProperties().html;
        var stationdata = features[0].getProperties().data;
        self.OpenDailog(stationdata);
      } else {
        overlay.setPosition(undefined);
        closer.blur();
      }
    });
  }

  flyTo(location, zoom) {
    var self = this;
    const duration = 2000;

    let parts = 2;
    let called = false;
    function callback(complete) {
      --parts;
      if (called) {
        return;
      }
      if (parts === 0 || !complete) {
        called = true;

      }
    }
    self.view.animate(
      {
        center: location,
        duration: duration,
      },
      callback
    );
    self.view.animate(
      {
        zoom: zoom - 1,
        duration: duration / 2,
      },
      {
        zoom: zoom,
        duration: duration / 2,
      },
      callback
    );
  }

  addLayerPolygon(features) {
    var self = this;
    if (self.LineAreaLayer != null) {

      self.map.removeLayer(self.LineAreaLayer);
    }

    self.LineAreaLayer = new VectorLayer({
      source: new VectorSource({
        url: 'data:,' + encodeURIComponent(features),
        format: new GeoJSON()
      }),
      style: new Style({
        stroke: new Stroke({
          /*color: 'rgb(23,109,248)',*/
          color: 'rgb(0,0,0)',
          width: 2,
        }),
        fill: new Fill({ color: "#898b8e33" }),
      }),

    });
    self.map.addLayer(self.LineAreaLayer);

  }

  ShowDate(date) {
    if (date == null || date == "" || date == undefined) {
      return "";
    } else {
      let dateTime = new Date(date);
      return new Intl.DateTimeFormat(this.currentLocale, { dateStyle: "full", timeStyle: "short", }).format(dateTime);
    }
  }

  
  ShowHourPM25() {
    new Popover(document.querySelectorAll('[data-bs-toggle="popover"]')[0]);

  }

  CloseDailog() {
    var closepopover = document.querySelectorAll('[data-bs-toggle="popover"]')[0] as HTMLElement;
    closepopover.click();
    this.ShowPopup = false;
    this.StationTime = null;
    this.AirQualityCalculateData = null;
  }

  async LoadStationDropdown(params, success, failure) {
    var self = this;
    var param = new StationParameter();
    param.StationName = params.data.term ? params.data.term : "";
    param.DistrictGroupId = this.DistrictGroupId;
    param.DistrictId = this.DistrictId;
    var service = Container.instance.get(DashboardAppService) as DashboardAppService;
    service.StationDropdown(param)
      .done((result) => {
        success(result);
      })
      .fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

  async LoadDistrictDropdown(params, success, failure) {
    var self = this;
    var param = new DistrictParameter();
    param.DistrictName = params.data.term ? params.data.term : "";
    param.DistrictGroupId = this.DistrictGroupId;
    param.DistrictId = this.DistrictId;
    var service = Container.instance.get(DashboardAppService) as DashboardAppService;
    service.DistrictDropdown2(param)
      .done((result) => {
        success(result);
      })
      .fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }

}

